import { supabase } from './supabase';
import { resolveMcpOrigin } from './mcpOrigin';

const baseUrl = (process.env.EXPO_PUBLIC_BASE_URL || 'https://paperzilla.ai').replace(/\/+$/, '');
export const MCP_SERVER_URL = `${baseUrl}/api/mcp`;

function accountOrigin(): string {
    return resolveMcpOrigin(baseUrl, typeof window === 'undefined' ? undefined : window.location?.origin);
}

export function getMcpServerUrl(): string {
    return `${accountOrigin()}/api/mcp`;
}

export interface McpConnection {
    id: string;
    client_id: string;
    client_name: string;
    scopes: string[];
    created_at: string;
    last_used_at: string | null;
}
export interface McpConsent {
    account_id: string;
    client_id: string;
    client_name: string;
    account_email: string;
    scopes: string[];
}

// Browser sign-in credentials go only to Paperzilla's account endpoints.
export async function mcpAccountRequest<T>(path: string, init: RequestInit = {}, authenticated = true): Promise<T> {
    const { data: { session } } = await supabase.auth.getSession();
    if (authenticated && (!session || session.user.is_anonymous)) {
        throw new Error('sign_in_required');
    }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
        const response = await fetch(`${accountOrigin()}/api/oauth${path}`, {
            ...init,
            credentials: 'include',
            signal: controller.signal,
            headers: {
                'Content-Type': 'application/json',
                ...(authenticated ? { Authorization: `Bearer ${session!.access_token}` } : {}),
                ...init.headers,
            },
        });
        if (!response.ok) {
            // Never display arbitrary OAuth/server response bodies or credentials.
            throw new Error(response.status === 400 ? 'request_expired' : 'request_failed');
        }
        return await response.json() as T;
    } finally {
        clearTimeout(timeout);
    }
}

export function consentPath(request: string): string {
    return `/oauth/consent?request=${encodeURIComponent(request)}`;
}

export function validConsentRequest(value: unknown): value is string {
    return typeof value === 'string' && /^pzo_request_[A-Za-z0-9_-]{43}$/.test(value);
}
